module.exports = __webpack_public_path__ + "img/attach-file-icon.eff8b20a.svg";